import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import SavedSearchSelect from '../SavedSearchSelect';
import SearchMyPropertyMatches from '../../searches/SearchMyPropertyMatches';
import ArrowRightIcon from '@icons/ArrowRightIcon';
import LoadingArea from '@molecules/LoadingArea';
import { BodyLarge, ButtonLink, LinkSmall } from '@styled';

import { getSavedSearchTitle } from '../../../helpers/savedSearches.helpers';
import useSavedSearches from '../../../hooks/useSavedSearches';
import colors from '@general/colors';

const FeaturedPropertiesMatches = ({ eventCode }) => {
    const history = useHistory();

    // -----------------------------
    // State
    // -----------------------------

    const [selectedSearch, setSelectedSearch] = useState();
    const [savedSearches, setSavedSearches] = useState();

    const { loading: savedSearchesLoading } = useSavedSearches({
        onCompleted: ({ savedSearches: savedSearchesIncoming }) => {
            const searchesFiltered = savedSearchesIncoming.filter(search => search.primaryInterest === 'SPACE', []);
            if (searchesFiltered.length === 0) {
                return;
            }

            setSavedSearches(searchesFiltered);
            setSelectedSearch(searchesFiltered[0]);
        },
    });

    // -----------------------------
    // Render
    // -----------------------------

    if (savedSearchesLoading) {
        return <LoadingArea />;
    }

    return (
        <div>
            {!selectedSearch && (
                <>
                    <BodyLarge className="mb-1rem">
                        Create a "looking for space" match criteria to see properties featured at this event.
                    </BodyLarge>

                    <ButtonLink
                        href="/my-icsc/connections/matches/new"
                        onClick={e => {
                            e.preventDefault();
                            history.push('/my-icsc/connections/matches/new');
                        }}
                    >
                        Create Match Criteria
                    </ButtonLink>
                </>
            )}

            {selectedSearch && (
                <>
                    <div className="align-items-start d-block d-md-flex justify-content-between mb-2rem">
                        <BodyLarge className="pr-1.75rem">
                            Properties matching "{getSavedSearchTitle(selectedSearch)}"
                        </BodyLarge>

                        <div className="d-block d-md-flex pt-0.25rem">
                            <SavedSearchSelect
                                savedSearches={savedSearches}
                                selectedSearch={selectedSearch}
                                onSavedSearchSelect={setSelectedSearch}
                            />
                        </div>
                    </div>

                    <SearchMyPropertyMatches
                        savedSearch={selectedSearch}
                        additionalFilters={`events:${eventCode}`}
                        hitsPerPage={6}
                        parentView="Events"
                        displayPagingToolbar
                        NoResultsText={() => (
                            <>Looks like no matches yet. Check back closer to the event or create new match criteria.</>
                        )}
                    />
                </>
            )}
        </div>
    );
};

FeaturedPropertiesMatches.propTypes = {
    eventCode: PropTypes.string.isRequired,
};

export default FeaturedPropertiesMatches;
